import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { SettingsApiService } from './settings-api.service';
import { BehaviorSubject } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
export var RegistrationType;
(function (RegistrationType) {
    RegistrationType[RegistrationType["Open"] = 1] = "Open";
    RegistrationType[RegistrationType["Moderated"] = 2] = "Moderated";
    RegistrationType[RegistrationType["Closed"] = 3] = "Closed";
})(RegistrationType || (RegistrationType = {}));
export var SystemSettingsConfirm;
(function (SystemSettingsConfirm) {
    SystemSettingsConfirm[SystemSettingsConfirm["Confirm"] = 1] = "Confirm";
})(SystemSettingsConfirm || (SystemSettingsConfirm = {}));
export const RegistrationTypeMap = new Map([
    [RegistrationType.Open, 'Global.Options.RegistrationType.Open'],
    [RegistrationType.Moderated, 'Global.Options.PayoutStatuses.Moderated'],
    [RegistrationType.Closed, 'Global.Options.RegistrationType.Closed'],
]);
export var RegistrationTypePermissions;
(function (RegistrationTypePermissions) {
    RegistrationTypePermissions["Open"] = "UI_Registration_Type_Open";
    RegistrationTypePermissions["Moderated"] = "UI_Registration_Type_Moderated";
    RegistrationTypePermissions["Closed"] = "UI_Registration_Type_Closed";
})(RegistrationTypePermissions || (RegistrationTypePermissions = {}));
export const RegistrationTypePermissionsMap = new Map([
    [RegistrationType.Open, RegistrationTypePermissions.Open],
    [RegistrationType.Moderated, RegistrationTypePermissions.Moderated],
    [RegistrationType.Closed, RegistrationTypePermissions.Closed],
]);
export const GENERAL_SETTINGS_SECTION = 'general-settings';
export const DEFAULT_REFERRAL_PROGRAM_SECTION = 'default-referral-program';
const defaultSettings = {
    registration_type_id: RegistrationType.Open,
    default_payment_terms_id: 0,
    system_commission_threshold: 0,
    default_affiliate_manager_id: 1,
    default_advertiser_id: 1,
    workspace_features: [
        'affiliate_billing',
        'capacity',
        'fraud_detection',
        'fraud_detection_reason',
        'marketing_campaigns',
        'offer_management',
        'payout_rules',
        'referral_program',
        'revenue_rules',
        'postback_management',
        'automation_rules',
        'logs',
        'user_operations',
        'reports',
        'lead_status',
        'hide_sale_order_sum',
        'advertiser_billing',
        'click_commissions',
        'automatically_create_revenue_rule',
        'push_brokers',
        'crg',
        'epl',
        'theming_customization',
        'cpa_network_solution',
    ],
};
let SettingsService = class SettingsService {
    constructor(_settingsApiService, _ngxPermissionsService) {
        this._settingsApiService = _settingsApiService;
        this._ngxPermissionsService = _ngxPermissionsService;
        this.system$ = new BehaviorSubject(defaultSettings);
        this._system = defaultSettings;
    }
    get settings() {
        return this._system;
    }
    list(params = {}) {
        return this._settingsApiService.list(params);
    }
    batchUpdate(section, body) {
        return this._settingsApiService.batchUpdate(section, body);
    }
};
SettingsService.ctorParameters = () => [
    { type: SettingsApiService },
    { type: NgxPermissionsService }
];
SettingsService = __decorate([
    Injectable({
        providedIn: 'root',
    }),
    __metadata("design:paramtypes", [SettingsApiService,
        NgxPermissionsService])
], SettingsService);
export { SettingsService };
